import { render } from "./LocationAdminSideNav.vue?vue&type=template&id=4c051ee2"
import script from "./LocationAdminSideNav.vue?vue&type=script&lang=js"
export * from "./LocationAdminSideNav.vue?vue&type=script&lang=js"

import "./LocationAdminSideNav.vue?vue&type=style&index=0&id=4c051ee2&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__